import { useState, useEffect } from 'react'
import { Typography, Button, IconButton, Box, Stack,
        InputLabel, TextField, Select, Table, TableContainer,
        TableHead, TableBody, TableRow, TableCell, Pagination,
        Checkbox, FormControlLabel
 } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import { useConfirm } from '@/components/ConfirmProvider'
import OrgSelectModal from '@/components/Modal/OrgSelectModal'
import { admSend } from 'api/users';
import { useLocation, useNavigate } from 'react-router-dom'
import { excelDown } from '@/utils/ExcelDown'

/**
 * 권한관리 
 **/
function AuthMng () {
  const { alert, confirm } = useConfirm();
  const navigate = useNavigate();
  const location = useLocation();

  /* 기관검색 팝업 */
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => setDialogOpen(true);   // Dialog Open
  const handleCloseDialog = () => setDialogOpen(false);  // Dialog Close
  
  /* pagenavigation */
  const [page, setPage]           = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const itemsPerPage = 10;

  const [paramData, setParamData] = useState({
    page : page, 
    authGradeCode : "",
    authGradeName : "",
    authGroupName : "",
  });     // 조회조건

  const [authList, setAuthList] = useState([]);
  const [selected, setSelected] = useState([]);

  const navParamData = location.state?.navParamData;
  const [searchYn, setSearchYn] = useState(location.state?.searchYn || "N");

// ====================== CSS ======================
  const headerCellStyle = {
    // width: '80px',
    bgcolor: 'grey.50'
    , borderTop: '1px solid'
    , borderColor: 'divider'
    // , cursor: 'pointer'
    , color: 'text.primary'
    , textAlign: 'center'
    , textDecoration: 'none'
  }

// ====================== 공통 함수 ======================
  // 전체 선택
  const handleSelectAll = (checked) => {
    // if( authList.length > 0){
      if (checked) {
        setSelected(authList.map((r) => r.authGroupId));
      } else {
        setSelected([]);
      }
    // }
  };

  // 단건 선택
  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };
  const allSelected = selected.length === authList.length;
  const someSelected = selected.length > 0 && !allSelected;

// ====================== 사용자 업무 함수 ======================
  // 검색
  const searchData = async () => {

    if (!paramData.authGradeCode) return alert("기관이 선택되지 않았습니다.");

    try {
      setSearchYn("Y");
      const resData = await admSend('/getAuthGrpList', paramData);
      setAuthList(resData.data?.content);
      //setTotalPage(resData.data?.totalPages); // page처리가 달라 관리자에서 사용이 어떻게 될지 몰라 임시 주석.
      setTotalPage(resData.data?.totalElements); // 임시 처리 전체 갯수
      
    } catch (error) {
      console.error('권한정보 불러오기 실패:', error);
    }
  };

  // 엑셀 다운로드
  const authMngExcelDown = async () => {

    try {
      const resData = await admSend('/getExcelAuthGrpList', paramData);
      const fileInfo = {
        fileNm : '사용자그룹',
        headers : [["번호", "권한명", "연관그룹", "작성자", "생성일"]],
      }
      const data = resData.data?.content?.map(item => ({
          rowNum : item.rowNum			          /* 번호 */
        , workGroupName : item.authGroupName	/* 권한명 */
        , authGroupName : item.authGradeName	/* 기관명 */
        , userCnt : item.relateGroupCnt			  /* 연관그룹수 */
        , registNm : item.registNm	      	  /* 작성자명 */
        , registDttm : item.registDttm		    /* 생성일 */
      }))

      excelDown(fileInfo, data);

    } catch (error) {
      console.error('권한정보 불러오기 실패:', error);
    }
  };

  const delAuth = async () => {
    // validation
    if ( !allSelected && !someSelected )
    {
      alert("삭제할 권한이 선택되지 않았습니다.");
      return;
    }

    const resConfirm = await confirm({title : '', message : '삭제하시겠습니까?'});

    if ( resConfirm ) {
      const resDel = await admSend('/deleteAuthGrpList', authList);

      if ( resDel ) {
        setSelected([]);  // 체크 정보 초기화
        searchData();     // 재조회
      }
    }

  };

  const onDetailAuth = (auth) => {
    // console.log(auth.authGroupId)
    navigate('/mng/authMngDetail', { state : { searchYn : searchYn, navParamData: paramData, dtlInfo : auth } });
  }

// ====================== CallBack 함수 ======================
// 기관검색 다이얼로그에서 콜백
  const handleConfirmInstitution = (inst) => {
    setParamData((p) => ({
      ...p,
      authGradeCode : inst.insttId,
      authGradeName : inst.insttNm
    }));
  };

  /* 페이지 이동시 조회 조건 가지고 다니기 */
  useEffect(() => {
    if( navParamData ) {
      // await
      setParamData({
        ...navParamData
      });
      setPage(navParamData.page ? navParamData.page : 1);
    }
  }, [ navParamData ]);

  /* 페이지 이동시 조회 조건 가지고 다니기 */
  useEffect(() => {
    if( searchYn === "Y" && navParamData && paramData.authGradeCode ) {
      searchData();
    }
  }, [ paramData.authGradeCode ]);

  /* page 이동 클릭시 */
  useEffect(() => {
    // 조회가 진행되고 기관 정보가 있는 경우 진행.(기관검색 처리 후 작동되도록 처리)
    if( searchYn === "Y" && paramData.authGradeCode )
    {
      // console.log("---->page")
      searchData();
    }
  }, [ page ]);

  return (
    <div>
      {/* 🔍 검색 조건 UI */}
      <Stack direction="row" alignItems="center" spacing={2}>
        <OrgSelectModal open={dialogOpen} onClose={handleCloseDialog} onSelect={handleConfirmInstitution} />
        {/* 기관 */}
        <Typography sx={{ width: 80 }}>기관명</Typography>
        <TextField
          sx={{ width: 580 }}
          id="insttName" 
          name="insttName" 
          label="기관명"
          value={paramData.authGradeName}
          onChange={(e) => {
            setParamData({
              ...paramData,
              instt : e.target.value
            })
          }}
          disabled={true}
        />

        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
          <Button 
            size="small"
            variant="outlined"
            onClick={handleOpenDialog}
            sx={{
              whiteSpace: 'nowrap',
              minWidth: 'auto',
              px: 2,
              py: 1,
              backgroundColor: '#FFF',
              '&:hover': {
                backgroundColor: '#FAFAFA'
              }
            }}
          >기관검색</Button>
        </Box>

        <Box sx={{ flex: 0, display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
          <IconButton
            sx={{ p: 0.8, border: '1px solid #ccc', borderRadius: '8px' }}
            aria-label="검색"
            onClick={() => {
              setSearchYn("N");
              setParamData({
                page : "1", 
                authGradeCode : "",
                authGradeName : "",
                authGroupName : "",
              });
              setAuthList([]);
              setTotalPage(0);
            }}>
            <RefreshIcon/>
          </IconButton>
          <Button
            sx={{ p: 3, border: '13px', borderRadius: '8px' }}
            variant="contained"
            color="primary"
            onClick={searchData}
          >검색</Button>
        </Box>

      </Stack>

      <Stack direction="row" alignItems="center" spacing={2}>
        {/* 권한명 */}
        <InputLabel sx={{ width: 80 }}>권한명</InputLabel>
        <TextField
          id="insttCode" 
          name="insttCode" 
          sx={{ width: 580 }}
          label="권한명"
          value={paramData.authGroupName}
          onChange={(e) => {
            setParamData({
              ...paramData,
              authGroupName : e.target.value
            })
          }}
          onKeyDown={(e) => {
            // 엔터 시 실행할 기능 추가
            if (e.key === "Enter") {
              searchData();
            }
          }}
        />
      </Stack>

      <Stack alignItems="left" justifyContent="flex-end" sx={{height : '60px'}}>
      총 : { totalPage }건
      </Stack>
      <TableContainer sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" sx={headerCellStyle}>
                <FormControlLabel
                  control={
                    <Checkbox
                      indeterminate={someSelected}
                      checked={allSelected}
                      onChange={(e) => handleSelectAll(e.target.checked)}
                    />
                  }
                  label={"전체선택"}
                />
              </TableCell>
              <TableCell sx={headerCellStyle}>번호</TableCell>
              <TableCell sx={headerCellStyle}>권한명</TableCell>
              <TableCell sx={headerCellStyle}>연관그룹</TableCell>
              <TableCell sx={headerCellStyle}>작성자</TableCell>
              <TableCell sx={headerCellStyle}>생성일</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {
              authList.length === 0 ? (
                <TableRow>
                  <TableCell align="center" colSpan={6}>검색된 데이터가 없습니다.</TableCell>
                </TableRow>
              ) : (
              authList.map((auth, index) => (
                <TableRow key={index}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      value={auth.rowChkYn === "Y" ? "Y" : "N"}
                      checked={selected.includes(auth.authGroupId)}
                      onChange={(e) => {
                        const checked = e.target.checked ? "Y" : "N";
                        handleSelect(auth.authGroupId); // 체크 상태 처리
                        // 조회 정보에 체크 상태 변경.
                        setAuthList((prev) =>
                          prev.map((item) =>
                            item.authGroupId === auth.authGroupId ? { ...item, rowChkYn : checked } : item
                          )
                        );
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">{auth.rowNum}</TableCell>
                  <TableCell align="left">
                    <span 
                      style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                      onClick={() => onDetailAuth(auth)}
                    >{auth.authGroupName}</span></TableCell>
                  <TableCell align="center">{auth.relateGroupCnt}</TableCell>
                  <TableCell align="center">{auth.registNm}</TableCell>
                  <TableCell align="center">{auth.registDttm}</TableCell>
                </TableRow>
              ))
              )
            }
          </TableBody>
        </Table>
      </TableContainer>

      {
      totalPage != 0 && (
      <Pagination
        count={Math.ceil((totalPage? totalPage : 0) / itemsPerPage)}
        page={page}
        onChange={(e, value) =>{
          // console.log("value:"+value);
          setParamData({
            ...paramData,
            page : value 
          });
          setPage(value);
        }
        }
        showFirstButton
        showLastButton
        sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
      />
      )
      }
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
          <Button
            sx={{ p: 3, border: '13px', borderRadius: '8px' }}
            variant="contained"
            onClick={() => {
              authMngExcelDown();
            }}
          >엑셀다운로드</Button>
          <Button
            sx={{ p: 3, border: '13px', borderRadius: '8px' }}
            variant="contained"
            color="primary"
            onClick={() => {
              delAuth();
            }}
          >삭제</Button>
          <Button
            sx={{ p: 3, border: '13px', borderRadius: '8px' }}
            variant="contained"
            color="primary"
            onClick={() => {
              navigate('/mng/authMngWrite', { state: {searchYn : searchYn, navParamData : paramData} });
            }}
          >등록</Button>
        </Box>

    </div>
  )
}

export default AuthMng;